"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _settings = _interopRequireWildcard(require("./settings.js"));
var _player = _interopRequireDefault(require("./player.css"));
var _settings2 = _interopRequireDefault(require("./settings.css"));
var _backgrounds = require("./backgrounds.js");
var _assistants = require("./assistants.js");
var _controls = require("./controls.js");
var _volumeHigh = _interopRequireDefault(require("cccisd-icons/svg/volume-high"));
var _volumeMute = _interopRequireDefault(require("cccisd-icons/svg/volume-mute2"));
var _calculator = _interopRequireDefault(require("cccisd-icons/svg/calculator"));
var _enlarge = _interopRequireDefault(require("cccisd-icons/svg/enlarge"));
var _shrink = _interopRequireDefault(require("cccisd-icons/svg/shrink"));
var _question = _interopRequireDefault(require("cccisd-icons/svg/question4"));
var _cccisdRenderInBody = _interopRequireDefault(require("cccisd-render-in-body"));
var _cccisdResponsive = _interopRequireDefault(require("cccisd-responsive"));
var _Calculator = _interopRequireDefault(require("./Calculator"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _get3 = _interopRequireDefault(require("lodash/get"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _classnames5 = _interopRequireDefault(require("classnames"));
var _cccisdSound = require("cccisd-sound");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _color = _interopRequireDefault(require("color"));
var _ScaleToFit = _interopRequireDefault(require("./ScaleToFit"));
var _avatar = _interopRequireDefault(require("./avatar"));
var _md = _interopRequireDefault(require("md5"));
var _style = _interopRequireDefault(require("../Player/flow/style.css"));
var _react2 = require("@emotion/react");
var _templateObject;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var xsmall = 600;
var small = 992;
var medium = 1200;
var DefaultFlowTemplate = /*#__PURE__*/function (_React$Component) {
  _inherits(DefaultFlowTemplate, _React$Component);
  var _super = _createSuper(DefaultFlowTemplate);
  function DefaultFlowTemplate() {
    var _this;
    _classCallCheck(this, DefaultFlowTemplate);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      contentHeight: 0,
      isMobilePageDescriptionVisible: _this.props.isMobilePageDescriptionVisible
    });
    _defineProperty(_assertThisInitialized(_this), "handleResize", (0, _debounce2["default"])(function () {
      _this.adjustContentHeight();
    }, 200));
    _defineProperty(_assertThisInitialized(_this), "adjustContentHeight", function () {
      if (!_this.props.playerTemplateSettings.showStickyBottomBar) {
        return;
      }
      var wrapperElement = _this.wrapperRef;
      if (wrapperElement) {
        if (_this.props.isFullscreen) {
          _this.setState({
            contentHeight: window.innerHeight
          });
          return;
        }
        var parent = wrapperElement.parentNode;
        while (parent && parent !== document) {
          if (parent.attributes['data-cccisd-survey-area']) {
            var wrapperRect = wrapperElement.getBoundingClientRect();
            var parentRect = parent.getBoundingClientRect();
            var parentStyles = window.getComputedStyle(parent);
            var offset = wrapperRect.top - parentRect.top;
            var parentHeight = parentRect.height;
            var height = parentHeight - parseFloat(parentStyles.paddingBottom) - offset;

            // don't go below some minimum height
            // substract 1 just to avoid issues with extra border
            _this.setState({
              contentHeight: Math.max(height - 1, 200)
            });
            return;
          }
          parent = parent.parentNode;
        }
        _this.setState({
          contentHeight: 'auto'
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleAudio", function () {
      _this.props.setEnableAudio(!_this.props.enableAudio);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleCalculator", function () {
      var isCalculatorVisible = (0, _get3["default"])(_this.props.storage, 'defaultTemplate.isCalculatorVisible', false);
      _this.props.setToStorage({
        defaultTemplate: _objectSpread(_objectSpread({}, _this.props.storage.defaultTemplate), {}, {
          isCalculatorVisible: !isCalculatorVisible
        })
      });
    });
    _defineProperty(_assertThisInitialized(_this), "saveCalculatorPosition", function (x, y) {
      _this.props.setToStorage({
        defaultTemplate: _objectSpread(_objectSpread({}, _this.props.storage.defaultTemplate), {}, {
          calculatorPosition: {
            x: x,
            y: y
          }
        })
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getUpscaleFactor", function () {
      var widthToStartScaling = 992;
      return Math.max(window.innerWidth / widthToStartScaling, 1);
    });
    _defineProperty(_assertThisInitialized(_this), "renderPrevButton", function () {
      var _this$props$playerTem = _this.props.playerTemplateSettings,
        prevButtonTitle = _this$props$playerTem.prevButtonTitle,
        showPrevButton = _this$props$playerTem.showPrevButton,
        controlStyle = _this$props$playerTem.controlStyle,
        pageTitleColor = _this$props$playerTem.pageTitleColor,
        prevSurveyButtonTitle = _this$props$playerTem.prevSurveyButtonTitle;
      var isVisible = _this.props.showPrevButton && showPrevButton;
      var visibleStyle = isVisible ? {} : {
        visibility: 'hidden'
      };
      var className = controlStyle ? _controls.controls[controlStyle].prevButtonClassName : 'btn btn-primary';
      var buttonTitle = prevButtonTitle;
      if (_this.props.pageFirstElementId === 0 && _this.props.goBack) {
        buttonTitle = prevSurveyButtonTitle;
      }
      if (controlStyle && _controls.controls[controlStyle].renderButton) {
        var result = _controls.controls[controlStyle].renderButton({
          type: 'prev',
          onClick: _this.props.onPrevButtonClick,
          title: (0, _react2.jsx)(_cccisdWysiwyg.Html, {
            content: buttonTitle
          }),
          color: (0, _settings.getTitleColor)(pageTitleColor)
        });
        if (result) {
          return (0, _react2.jsx)("div", {
            style: visibleStyle
          }, result);
        }
      }
      return (0, _react2.jsx)("a", {
        className: className,
        onClick: _this.props.onPrevButtonClick,
        style: visibleStyle
      }, (0, _react2.jsx)(_cccisdWysiwyg.Html, {
        content: buttonTitle
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderNextButton", function () {
      if (!_this.props.showNextButton) {
        return null;
      }
      var _this$props$playerTem2 = _this.props.playerTemplateSettings,
        controlStyle = _this$props$playerTem2.controlStyle,
        pageTitleColor = _this$props$playerTem2.pageTitleColor,
        nextButtonTitle = _this$props$playerTem2.nextButtonTitle;
      var className = controlStyle ? _controls.controls[controlStyle].nextButtonClassName : 'btn btn-primary';
      if (controlStyle && _controls.controls[controlStyle].renderButton) {
        var result = _controls.controls[controlStyle].renderButton({
          type: 'next',
          onClick: _this.props.onNextButtonClick,
          title: (0, _react2.jsx)(_cccisdWysiwyg.Html, {
            content: nextButtonTitle
          }),
          color: (0, _settings.getTitleColor)(pageTitleColor)
        });
        if (result) {
          return result;
        }
      }
      return (0, _react2.jsx)("a", {
        className: className,
        onClick: _this.props.onNextButtonClick
      }, (0, _react2.jsx)(_cccisdWysiwyg.Html, {
        content: nextButtonTitle
      }));
    });
    // we need this button to preserve bottomBar height
    _defineProperty(_assertThisInitialized(_this), "renderFakeButton", function () {
      if (_this.props.showCompleteButton || _this.props.showNextButton) {
        return null;
      }
      var controlStyle = _this.props.playerTemplateSettings.controlStyle;
      var className = controlStyle ? _controls.controls[controlStyle].nextButtonClassName : 'btn btn-primary';
      return (0, _react2.jsx)("span", {
        style: {
          position: 'relative',
          left: '9999px'
        }
      }, (0, _react2.jsx)("a", {
        className: className
      }, "Fake"));
    });
    _defineProperty(_assertThisInitialized(_this), "renderCompleteButton", function () {
      if (!_this.props.showCompleteButton) {
        return null;
      }
      var _this$props$playerTem3 = _this.props.playerTemplateSettings,
        controlStyle = _this$props$playerTem3.controlStyle,
        pageTitleColor = _this$props$playerTem3.pageTitleColor,
        completeButtonTitle = _this$props$playerTem3.completeButtonTitle;
      var className = controlStyle ? _controls.controls[controlStyle].completeButtonClassName : 'btn btn-primary';
      if (controlStyle && _controls.controls[controlStyle].renderButton) {
        var result = _controls.controls[controlStyle].renderButton({
          type: 'complete',
          onClick: _this.props.onCompleteButtonClick,
          title: (0, _react2.jsx)(_cccisdWysiwyg.Html, {
            content: completeButtonTitle
          }),
          color: (0, _settings.getTitleColor)(pageTitleColor)
        });
        if (result) {
          return result;
        }
      }
      return (0, _react2.jsx)("a", {
        className: className,
        onClick: _this.props.onCompleteButtonClick
      }, (0, _react2.jsx)(_cccisdWysiwyg.Html, {
        content: completeButtonTitle
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderFeedbackButton", function () {
      if (!_this.props.showFeedbackButton) {
        return null;
      }
      var _this$props$playerTem4 = _this.props.playerTemplateSettings,
        controlStyle = _this$props$playerTem4.controlStyle,
        pageTitleColor = _this$props$playerTem4.pageTitleColor,
        feedbackButtonTitle = _this$props$playerTem4.feedbackButtonTitle;
      var className = controlStyle ? _controls.controls[controlStyle].feedbackButtonClassName : 'btn btn-primary';
      if (controlStyle && _controls.controls[controlStyle].renderButton) {
        var result = _controls.controls[controlStyle].renderButton({
          type: 'feedback',
          onClick: _this.props.onNextButtonClick,
          title: (0, _react2.jsx)(_cccisdWysiwyg.Html, {
            content: feedbackButtonTitle
          }),
          color: (0, _settings.getTitleColor)(pageTitleColor)
        });
        if (result) {
          return result;
        }
      }
      return (0, _react2.jsx)("a", {
        className: className,
        onClick: _this.props.onNextButtonClick
      }, (0, _react2.jsx)(_cccisdWysiwyg.Html, {
        content: feedbackButtonTitle
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderProgressBar", function () {
      if (!_this.props.playerTemplateSettings.showProgressBar) {
        return null;
      }
      return _this.props.progressBar;
    });
    _defineProperty(_assertThisInitialized(_this), "renderAssistant", function (position) {
      var _this$props$playerTem5 = _this.props.playerTemplateSettings,
        assistant = _this$props$playerTem5.assistant,
        assistantAvatar = _this$props$playerTem5.assistantAvatar;
      var assistantPosition = position || _this.props.playerTemplateSettings.assistantPosition;
      if (!assistant) {
        return null;
      }
      var settings;
      if (assistant === 'avatar') {
        var defaultChoices = {
          hairStyle1: 2,
          hairStyle2: 0,
          hairColor: 0,
          skinColor: 8,
          lipsColor: 8,
          eyesColor: 10,
          eyeShape: 0,
          shirtColor: 0,
          pantsColor: 0,
          shoesColor: 0,
          noseShape: 0,
          faceShape: 0,
          mouthShape: 0
        };
        var actualChoices = _objectSpread(_objectSpread({}, defaultChoices), assistantAvatar);
        var params = {
          avatar: 'MiddleSchool',
          style: assistantPosition === 'corner' ? 'corner' : 'default',
          idx: 0,
          scale: 2,
          choices: JSON.stringify(actualChoices)
        };
        var stringifiedParams = Object.entries(params).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          return "".concat(key, "=").concat(encodeURIComponent(value));
        }).join('&');
        var secret = 'secret statement!'; // should match the secret from microservice
        var hash = (0, _md["default"])(stringifiedParams + secret).slice(-6);
        var urls = {
          side: ["https://avatar-render.service.3cisd.com/?" + stringifiedParams + '&hash=' + hash],
          corner: ["https://avatar-render.service.3cisd.com/?" + stringifiedParams + '&hash=' + hash]
        };
        settings = (0, _avatar["default"])(urls);
      } else {
        settings = _assistants.assistants[assistant];
      }
      var Assistant;
      var className;
      if (assistantPosition === 'side') {
        Assistant = settings.Side;
        className = _player["default"].side;
      } else if (assistantPosition === 'middle') {
        Assistant = settings.Middle;
        className = _player["default"].middle;
      } else {
        Assistant = settings.Corner;
        className = _player["default"].corner;
      }
      return (0, _react2.jsx)("div", {
        className: "".concat(_player["default"].assistant, " ").concat(className)
      }, (0, _react2.jsx)(Assistant, {
        isTalking: _this.props.parameters.isTalking
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderAudioToggle", function () {
      if (!_this.props.playerTemplateSettings.showAudioToggle) {
        return null;
      }
      var controlStyle = _this.props.playerTemplateSettings.controlStyle;

      // If default one
      if (!controlStyle) {
        return (0, _react2.jsx)("div", {
          id: _this.props.enableAudio ? 'flowAudioToggleEnabled' : 'flowAudioToggleDisabled',
          className: _player["default"].audioToggle,
          onClick: _this.toggleAudio
        }, _this.props.enableAudio ? (0, _react2.jsx)(_volumeHigh["default"], null) : (0, _react2.jsx)(_volumeMute["default"], null));
      }
      var _controls$controlStyl = _controls.controls[controlStyle],
        audioOnClassName = _controls$controlStyl.audioOnClassName,
        audioOffClassName = _controls$controlStyl.audioOffClassName;
      return (0, _react2.jsx)("div", {
        className: _this.props.enableAudio ? audioOnClassName : audioOffClassName,
        onClick: _this.toggleAudio
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderCalculator", function () {
      if (!_this.props.playerTemplateSettings.showCalculator) {
        return null;
      }
      var _get2 = (0, _get3["default"])(_this.props.storage, 'defaultTemplate', {}),
        calculatorPosition = _get2.calculatorPosition,
        isCalculatorVisible = _get2.isCalculatorVisible;
      return (0, _react2.jsx)("div", {
        className: _player["default"].audioToggle,
        onClick: _this.toggleCalculator
      }, (0, _react2.jsx)(_calculator["default"], null), isCalculatorVisible && (0, _react2.jsx)(_Calculator["default"], {
        close: _this.toggleCalculator,
        calculatorPosition: calculatorPosition,
        saveCalculatorPosition: _this.saveCalculatorPosition
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderFullscreenToggle", function () {
      if (!_this.props.playerTemplateSettings.showStickyBottomBar || !_this.props.playerTemplateSettings.showFullscreenToggle || !_this.props.canFullscreen) {
        return null;
      }
      return (0, _react2.jsx)("div", {
        className: _player["default"].audioToggle,
        onClick: _this.props.fullscreenToggle,
        title: "Fullscreen"
      }, _this.props.isFullscreen ? (0, _react2.jsx)(_shrink["default"], null) : (0, _react2.jsx)(_enlarge["default"], null));
    });
    _defineProperty(_assertThisInitialized(_this), "renderBubble", function () {
      if (_this.props.bubbleMessages.length === 0) {
        return null;
      }
      return (0, _react2.jsx)("div", {
        className: _player["default"].bubbleMessage
      }, _this.props.bubbleMessages.map(function (message, index) {
        return (0, _react2.jsx)("div", {
          key: index
        }, (0, _react2.jsx)(_cccisdWysiwyg.Html, {
          content: message.text,
          registerAction: _this.props.registerAction.bind(null, index),
          setParameters: _this.props.setParameters,
          accommodations: _this.props.accommodations
        }));
      }), (0, _react2.jsx)("div", {
        className: _player["default"].triangle
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderElementBlock", function () {
      var _this$props = _this.props,
        completeMessage = _this$props.completeMessage,
        elementBlock = _this$props.elementBlock,
        isFullscreen = _this$props.isFullscreen;
      var elementStyle = _this.props.playerTemplateSettings.elementStyle;
      var ignoreScaling = !_this.props.playerTemplateSettings.showStickyBottomBar || !_this.props.playerTemplateSettings.scaleContent || !_this.props.allowScaling;
      var upscaleFactor = isFullscreen && _this.props.playerTemplateSettings.showStickyBottomBar && _this.props.playerTemplateSettings.scaleContent ? _this.getUpscaleFactor() : 1;
      return (0, _react2.jsx)("div", {
        className: _player["default"].elementBlockWrapper
      }, (0, _react2.jsx)(_ScaleToFit["default"], {
        className: _player["default"].elementBlock,
        ignore: ignoreScaling,
        upscaleFactor: upscaleFactor
      }, completeMessage && (0, _react2.jsx)("div", {
        className: _player["default"].completeMessage + ' ' + _player["default"][elementStyle]
      }, _this.props.playerTemplateSettings.completeMessage), elementBlock));
    });
    _defineProperty(_assertThisInitialized(_this), "renderPageDescription", function (isTooltip) {
      var _classnames;
      var _this$props$playerTem6 = _this.props.playerTemplateSettings,
        pageTitleColor = _this$props$playerTem6.pageTitleColor,
        pageDescription = _this$props$playerTem6.pageDescription;
      if (!pageDescription) {
        return null;
      }
      var accommodations = _this.props.accommodations;
      var pageTitleColorHex = (0, _settings.getTitleColor)(pageTitleColor);
      var descriptionAudioUrl = (0, _get3["default"])(pageDescription, 'meta.audio.url');
      return (0, _react2.jsx)("div", {
        className: (0, _classnames5["default"])(_player["default"].pageDescription, (_classnames = {}, _defineProperty(_classnames, _player["default"].withAudio, descriptionAudioUrl), _defineProperty(_classnames, _player["default"].isTooltip, isTooltip), _classnames))
      }, descriptionAudioUrl && (0, _react2.jsx)(_cccisdSound.Player, _extends({
        src: descriptionAudioUrl,
        render: function render(_ref3) {
          var button = _ref3.button,
            onButtonClick = _ref3.onButtonClick;
          return (0, _react2.jsx)("div", {
            className: _player["default"].playDescription,
            style: {
              borderColor: pageTitleColorHex,
              color: pageTitleColorHex
            },
            onClick: onButtonClick
          }, button);
        }
      }, accommodations.autoplayInstructions && {
        registerAction: _this.props.registerAction.bind(_assertThisInitialized(_this), 1)
      })), (0, _react2.jsx)(_cccisdWysiwyg.Html, {
        content: pageDescription,
        clickplay: false
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "getBackgroundClassName", function () {
      var background = _this.props.playerTemplateSettings.background;
      if (!background || !_backgrounds.backgrounds[background]) {
        return '';
      }
      var className = _backgrounds.backgrounds[background].className;
      return className;
    });
    _defineProperty(_assertThisInitialized(_this), "getBackgroundStyle", function () {
      var _this$props$playerTem7 = _this.props.playerTemplateSettings,
        background = _this$props$playerTem7.background,
        backgroundColor = _this$props$playerTem7.backgroundColor,
        backgroundImage = _this$props$playerTem7.backgroundImage,
        backgroundSize = _this$props$playerTem7.backgroundSize;
      var bgStyle = {};
      if (background === 'solidColor') {
        bgStyle.backgroundColor = backgroundColor || '#000';
      }
      if (background === 'uploadedImage' && backgroundImage) {
        bgStyle.background = "url(".concat(backgroundImage.url, ")");
        if (backgroundSize === 'scale') {
          bgStyle.backgroundSize = '100% 100%';
        } else if (backgroundSize === 'bottom') {
          bgStyle.backgroundSize = '100% auto';
          bgStyle.backgroundPosition = 'center bottom';
          bgStyle.backgroundRepeat = 'no-repeat';
        }
      }
      return bgStyle;
    });
    _defineProperty(_assertThisInitialized(_this), "hasBackground", function () {
      return Boolean(_this.props.playerTemplateSettings.background);
    });
    return _this;
  }
  _createClass(DefaultFlowTemplate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.adjustContentHeight();
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$playerTem8 = this.props.playerTemplateSettings,
        height = _this$props$playerTem8.height,
        showTitle = _this$props$playerTem8.showTitle,
        showPageTitleDescription = _this$props$playerTem8.showPageTitleDescription,
        showAudioToggle = _this$props$playerTem8.showAudioToggle,
        showCalculator = _this$props$playerTem8.showCalculator,
        showFullscreenToggle = _this$props$playerTem8.showFullscreenToggle,
        assistant = _this$props$playerTem8.assistant,
        assistantPosition = _this$props$playerTem8.assistantPosition,
        elementFontSize = _this$props$playerTem8.elementFontSize,
        elementStyle = _this$props$playerTem8.elementStyle,
        adjustedPlayerWrapperStyle = _this$props$playerTem8.adjustedPlayerWrapperStyle,
        adjustedPlayerWrapperClassName = _this$props$playerTem8.adjustedPlayerWrapperClassName,
        title = _this$props$playerTem8.title,
        pageTitle = _this$props$playerTem8.pageTitle,
        pageTitleColor = _this$props$playerTem8.pageTitleColor,
        pageDescription = _this$props$playerTem8.pageDescription,
        showStickyBottomBar = _this$props$playerTem8.showStickyBottomBar;
      var isMobilePageDescriptionVisible = this.state.isMobilePageDescriptionVisible;
      var _this$props2 = this.props,
        isPreview = _this$props2.isPreview,
        flowId = _this$props2.flowId;
      var showTopBar = showTitle || showPageTitleDescription || showAudioToggle || showCalculator || showFullscreenToggle;
      var pageTitleColorHex = (0, _settings.getTitleColor)(pageTitleColor);
      var pageTitleColorHexDarken = (0, _color["default"])(pageTitleColorHex).darken(0.1).hex();
      var isLightColor = (0, _color["default"])(pageTitleColorHex).luminosity() > 0.5;
      var rightButton = (0, _react2.jsx)("div", null, this.renderFakeButton(), this.renderCompleteButton(), this.renderNextButton(), this.renderFeedbackButton());
      var isBuilderPreview = isPreview && !flowId;
      var contentHeight = isBuilderPreview && !this.props.isFullscreen ? 'calc(100vh - 10em)' : this.state.contentHeight;
      return (0, _react2.jsx)("div", {
        ref: function ref(elem) {
          _this2.wrapperRef = elem;
        },
        className: (0, _classnames5["default"])(_player["default"].top, !this.hasBackground() && _player["default"].extraPadding, !showStickyBottomBar && this.props.isFullscreen && _player["default"].scrollable)
      }, (0, _react2.jsx)(_cccisdResponsive["default"], {
        stylesheet: _player["default"],
        widthBreakpoints: {
          xsmall: xsmall,
          small: small,
          medium: medium
        },
        render: function render(_ref4) {
          var _classnames2;
          var width = _ref4.width;
          return (0, _react2.jsx)("div", _extends({
            className: (0, _classnames5["default"])(_player["default"].wrapper, _this2.getBackgroundClassName(), _settings2["default"][elementFontSize], (_classnames2 = {}, _defineProperty(_classnames2, _player["default"]["assistant".concat(assistantPosition)], assistant), _defineProperty(_classnames2, _player["default"].noBubble, _this2.props.bubbleMessages.length === 0), _defineProperty(_classnames2, _player["default"].withBackground, _this2.hasBackground()), _classnames2), adjustedPlayerWrapperClassName),
            style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _this2.getBackgroundStyle()), !showStickyBottomBar && height && {
              minHeight: height
            }), adjustedPlayerWrapperStyle), showStickyBottomBar && {
              height: contentHeight
            })
          }, showStickyBottomBar ? {
            'data-cccisd-sticky-bottom-bar': true
          } : null), showTopBar && (0, _react2.jsx)("div", {
            className: _player["default"].topBar
          }, (0, _react2.jsx)("div", {
            className: _player["default"].titleBlock
          }, showTitle && (0, _react2.jsx)("h2", {
            style: {
              margin: '0'
            },
            className: _player["default"].title + ' ' + _player["default"][elementStyle]
          }, (0, _react2.jsx)(_cccisdWysiwyg.Html, {
            content: title
          })), showPageTitleDescription && (0, _react2.jsx)("div", {
            className: _player["default"].pageBlock
          }, (0, _react2.jsx)("div", {
            className: _player["default"].pageTitleWrapper
          }, (0, _react2.jsx)("div", {
            className: (0, _classnames5["default"])(_player["default"].pageTitle, _defineProperty({}, _player["default"].withDescription, !!pageDescription)),
            style: {
              borderColor: pageTitleColorHexDarken,
              backgroundColor: pageTitleColorHex,
              color: isLightColor ? '#333' : '#fff'
            }
          }, (0, _react2.jsx)(_cccisdWysiwyg.Html, {
            content: pageTitle
          })), width < xsmall && pageDescription && (0, _react2.jsx)("span", {
            className: _player["default"].pageDescriptionToggle,
            style: {
              borderColor: pageTitleColorHexDarken
            }
          }, (0, _react2.jsx)(_cccisdTooltip["default"], {
            title: _this2.renderPageDescription(true),
            placement: "bottom",
            maxWidth: "100vw",
            tippyProps: {
              theme: 'light',
              onTrigger: function onTrigger() {
                _this2.setState({
                  isMobilePageDescriptionVisible: true
                });
              },
              onHide: function onHide() {
                _this2.setState({
                  isMobilePageDescriptionVisible: false
                });
              },
              hideOnClick: true,
              trigger: 'click',
              showOnCreate: isMobilePageDescriptionVisible,
              interactive: true,
              appendTo: document.body
            }
          }, (0, _react2.jsx)("button", {
            className: _player["default"].pageDescriptionTooltip,
            type: "button"
          }, (0, _react2.jsx)(_question["default"], null))), (0, _react2.jsx)(_cccisdRenderInBody["default"], null, isMobilePageDescriptionVisible && (0, _react2.jsx)("div", {
            className: _player["default"].pageDesriptionTooltipBackdrop
          })))), width >= xsmall && _this2.renderPageDescription())), (0, _react2.jsx)("div", {
            className: _player["default"].buttonsWrapper
          }, _this2.renderCalculator(), _this2.renderAudioToggle(), _this2.renderFullscreenToggle())), (0, _react2.jsx)("div", {
            className: (0, _classnames5["default"])(_defineProperty({}, _player["default"].fitHeight, showStickyBottomBar && contentHeight !== 'auto')),
            id: "cccisd-flow-content-area",
            style: {
              flexGrow: 1
            }
          }, function () {
            if (assistant && assistantPosition === 'corner' && _this2.props.bubbleMessages.length !== 0) {
              return (0, _react2.jsx)(_react["default"].Fragment, null, (0, _react2.jsx)("div", {
                className: _player["default"].row
              }, _this2.renderBubble(), _this2.renderAssistant()), _this2.renderElementBlock());
            }
            if (assistant && assistantPosition === 'middle') {
              return (0, _react2.jsx)("div", {
                className: _player["default"].body
              }, (0, _react2.jsx)("div", {
                className: _player["default"].row
              }, _this2.renderBubble(), _this2.renderElementBlock()), _this2.renderAssistant());
            }
            return (0, _react2.jsx)(_react["default"].Fragment, null, _this2.renderBubble(), (0, _react2.jsx)("div", {
              className: _player["default"].body
            }, _this2.renderElementBlock(), _this2.renderAssistant()));
          }()), _this2.props.showBottomBar && (0, _react2.jsx)("div", {
            id: "cccisd-flow-bottom-bar",
            className: _player["default"].bottomBar,
            css: (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                                        a.btn {\n                                            background-color: ", ";\n                                            border-color: ", ";\n                                            color: ", ";\n                                            &:hover {\n                                                background-color: ", ";\n                                                border-color: ", ";\n                                            }\n                                        }\n                                        .progress-bar {\n                                            background-color: ", ";\n                                        }\n                                        .", " {\n                                            border: 1px solid ", ";\n                                        }\n                                        .", ".", " {\n                                            background-color: ", ";\n                                        }\n                                    "])), pageTitleColorHex, pageTitleColorHexDarken, isLightColor ? '#333' : '#fff', pageTitleColorHexDarken, pageTitleColorHexDarken, pageTitleColorHex, _style["default"].item, pageTitleColorHex, _style["default"].item, _style["default"].past, pageTitleColorHex)
          }, (0, _react2.jsx)("div", null, _this2.renderPrevButton()), (0, _react2.jsx)("div", {
            className: _player["default"].progressBar
          }, _this2.renderProgressBar()), (0, _react2.jsx)("div", {
            className: _player["default"].rightButton
          }, _this2.props.onBeforeNextPageError ? (0, _react2.jsx)(_cccisdTooltip["default"], {
            title: _this2.props.onBeforeNextPageError,
            type: "error",
            placement: "top-right",
            tippyProps: {
              trigger: 'manual',
              showOnCreate: true,
              hideOnClick: false,
              appendTo: 'parent' // to be visible on fullscreen mode
            }
          }, rightButton) : rightButton)));
        }
      }));
    }
  }]);
  return DefaultFlowTemplate;
}(_react["default"].Component);
_defineProperty(DefaultFlowTemplate, "propTypes", {
  settings: _propTypes["default"].object,
  progressBar: _propTypes["default"].element,
  isCompleteMessage: _propTypes["default"].bool,
  prevButton: _propTypes["default"].element,
  nextButton: _propTypes["default"].element,
  completeButton: _propTypes["default"].element,
  completeMessage: _propTypes["default"].element,
  elementBlock: _propTypes["default"].node,
  // Advanced props
  registerAction: _propTypes["default"].func,
  accommodations: _propTypes["default"].object,
  setParameters: _propTypes["default"].func,
  playerTemplateSettings: _propTypes["default"].object,
  showPrevButton: _propTypes["default"].bool,
  onPrevButtonClick: _propTypes["default"].func,
  showNextButton: _propTypes["default"].bool,
  onNextButtonClick: _propTypes["default"].func,
  showCompleteButton: _propTypes["default"].bool,
  onCompleteButtonClick: _propTypes["default"].func,
  onCorrectPreviousAnswers: _propTypes["default"].func,
  showFeedbackButton: _propTypes["default"].bool,
  pages: _propTypes["default"].array,
  progressBarPercent: _propTypes["default"].number,
  isErrorOnThePage: _propTypes["default"].bool,
  parentsPages: _propTypes["default"].array,
  parameters: _propTypes["default"].object,
  bubbleMessages: _propTypes["default"].array,
  enableAudio: _propTypes["default"].bool,
  setEnableAudio: _propTypes["default"].func,
  storage: _propTypes["default"].object,
  setToStorage: _propTypes["default"].func,
  onBeforeNextPageError: _propTypes["default"].string,
  isMobilePageDescriptionVisible: _propTypes["default"].bool,
  showBottomBar: _propTypes["default"].bool,
  fullscreenToggle: _propTypes["default"].func,
  isFullscreen: _propTypes["default"].bool,
  canFullscreen: _propTypes["default"].bool
});
var _default = {
  name: 'default',
  title: 'Default',
  component: DefaultFlowTemplate,
  settingsComponent: _settings["default"],
  defaultSettings: _settings.initialValues,
  getAssetsToPreload: function getAssetsToPreload(_ref5) {
    var templateSettings = _ref5.templateSettings;
    var assets = [];
    var assistant = _assistants.assistants[templateSettings.assistant];
    if (assistant && assistant.assets) {
      assets = [].concat(_toConsumableArray(assets), _toConsumableArray(assistant.assets));
    }
    var background = _backgrounds.backgrounds[templateSettings.background];
    if (background && background.assets) {
      assets = [].concat(_toConsumableArray(assets), _toConsumableArray(background.assets));
    }
    var controlStyle = _controls.controls[templateSettings.controlStyle];
    if (controlStyle && controlStyle.assets) {
      assets = [].concat(_toConsumableArray(assets), _toConsumableArray(controlStyle.assets));
    }
    return assets;
  }
};
exports["default"] = _default;